import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { ClientBrowserSessionStorageService } from '../../../services/client-browser-session-storage.service';
import { Commons } from '../../Commons';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-fullscreen-alert',
  standalone: true,
  imports: [
    TranslocoModule,
    CommonModule
  ],
  templateUrl: './fullscreen-alert.component.html',
  styleUrl: './fullscreen-alert.component.scss'
})
export class FullscreenAlertComponent {

  constructor(
    private router: Router,
    private sessionStorageService: ClientBrowserSessionStorageService
  ) { }

  get sessionOpen() {
    return Commons.sessionIsOpen(this.sessionStorageService);
  }

  openLink() {
    if (!this.sessionOpen) {
      this.router.navigate([Commons.PATH_LOGIN])
    } else {
      this.router.navigate([Commons.PATH_PRODUCT])
    }
  }

}
